















































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as data from "../../_store/data.module";
import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
import { userUtils } from "../../_utils/userUtils";
import { EnterpriseInfo } from "../../_models/enterpriseInfo";
import * as temp from "../../_store/temp.module";
import { router } from "../../_router";
import CreateDialog from "../../components/Dialogs/CreateDialog.vue";

@Component({
  components: {
    CardTitle,
    DetailsDataTable,
    CreateDialog
  }
})
export default class ColloquiAzienda extends Vue {
  @Prop() idIscrizioneAttivita!: number;
  @Prop() idIstituto!: number;
  @Prop() idAnnoScolastico!: number;
  @Prop() statoPeriodoIscrizione!: boolean;
  @Prop() statoPubblicazione!: boolean;
  @Prop() dataFineAttivita!: string;

  private titleParams: object;
  private dataTableParams: any;
  private createDialogParams: object;
  private schedules: any;
  private dialogColloquio: boolean;
  private allievoSelezionato: number | null;
  private articolazioneAllievo: number | null;
  private allieviList: any[];
  private turno: number | null;
  private allievoRules: any[];
  private tuttiAllievi: any[];
  private collapsedSettori: { [key: string]: boolean };

  private giorniColloqui: any;

  private enableChanges: boolean;
  private listaPreferenze: any;
  private showCreate: boolean;
  private published: boolean;

  constructor() {
    super();
    this.enableChanges = true;
    this.published = false;
    this.listaPreferenze = [];
    this.giorniColloqui = [];
    this.showCreate = true;
    this.titleParams = {
      title: "Colloqui",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParams = {
      headers: [
        {
          text: "Allievo",
          value: "username",
          sortable: false
        },
        {
          text: "Classe",
          value: "classe",
          sortable: false
        },
        {
          text: "Email Allievo/a",
          value: "emailUtente"
        },
        // {
        //   text: "Dettagli Allievo",
        //   value: "action",
        //   sortable: false
        // },
        {
          text: "Turno Colloquio",
          value: "turno"
        },
        {
          text: "Giorno Colloquio",
          value: "giorno"
        },
        {
          text: "Condividi Stanza",
          value: "condividiStanza",
          sortable: false
        },
        {
          text: "Report Colloquio",
          value: "questionarioColloquio",
          sortable: false
        }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI ALLIEVO",
        type: "userTab"
      },
      detailsColloquioDialogParams: {
        title: "QUESTIONARIO COLLOQUIO",
        type: "infoColloquio"
      },
      colloquioDialogParams: {
        title: "QUESTIONARIO COLLOQUIO",
        type: "colloquio"
      },
      type: "colloqui"
    };
    this.createDialogParams = {
      visible: true,
      idIstituto: this.idIstituto,
      isIscrizioneAttivita: this.idIscrizioneAttivita,
      type: "nuovaPreferenzaColloquio"
    };
    this.schedules = [];
    this.dialogColloquio = false;
    this.allievoSelezionato = null;
    this.articolazioneAllievo = null;
    this.allieviList = [];
    this.turno = null;
    this.allievoRules = [v => !!v || 'Selezionare un allievo'];
    this.tuttiAllievi = [];
    this.collapsedSettori = {};
  }

  toggleSettore(idArticolazione: string) {
    this.$set(this.collapsedSettori, idArticolazione, !this.collapsedSettori[idArticolazione]);
  }

  get oggi(): string {
    const d = new Date();
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }

  get settoriConSchedule() {
    const parseItalianDate = (dateStr: string): Date => {
      const [day, month, year] = dateStr.split('/').map(Number);
      return new Date(year, month - 1, day);
    };
    const oggi = parseItalianDate(this.oggi);
    return this.listaPreferenze
      .map((preferenza: any) => {
        const schedule = this.schedules.find((s: any) => s.idArticolazione === preferenza.idArticolazione) || null;
        const giorno = this.giorniColloqui.find((g: any) => g.idArticolazione === preferenza.idArticolazione) || null;
        return { preferenza, schedule, dataColloquio: giorno ? giorno.dataColloquio : null };
      })
      .filter((item: any) => {
        if (!item.dataColloquio) return false;
        return parseItalianDate(item.dataColloquio) <= oggi;
      });
  }

  openDialogColloquio(settore: any) {
    this.articolazioneAllievo = settore.idArticolazione;
    this.allievoSelezionato = null;
    this.allieviList = this.tuttiAllievi.filter(
      (a: any) => a.idArticolazione === settore.idArticolazione
    );
    this.dialogColloquio = true;
  }

  closeDialogColloquio() {
    this.dialogColloquio = false;
    this.allievoSelezionato = null;
    this.articolazioneAllievo = null;
  }

  saveColloquio() {
    var form = this.$refs.formColloquio as any;
    if (!form.validate()) return;
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
    var payload = {
      idAllievo: this.allievoSelezionato as number,
      idAzienda: enterpriseInfo.idAzienda,
      idIstituto: this.idIstituto,
      idArticolazione: this.articolazioneAllievo as unknown as string,
      idAnnoScolastico: idAnnoScolastico,
      nTurno: 0
    };
    user
      .dispatchRegisterSchedule(this["$store"], payload)
      .then(() => {
        bus.$emit("successfullOperation", "Colloquio creato con successo");
        bus.$emit("createdColloquio");
        this.closeDialogColloquio();
        this.schedules = [];
        this.loadColloqui();
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  loadAllievi() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var payload = {
      idIstituto: this.idIstituto,
      idAnnoScolastico: idAnnoScolastico
    };
    data
      .dispatchAssegnazioniAreeAllievi(this["$store"], payload)
      .then(result => {
        this.tuttiAllievi = result;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  loadColloqui() {
    // var schedules = [];
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var record: any;
    var schedule: {
      idArticolazione: number;
      linkStanza: string;
      tableRecords: any;
    };
    var articolazioniList: any = [];
    var articolazione: string;
    var enterpriseInfo: EnterpriseInfo = user.readEnterpriseInfo(
      this["$store"]
    );
    var payload = {
      idAnnoScolastico: idAnnoScolastico,
      idAzienda: enterpriseInfo.idAzienda
    };
    var link: string | null = "";
    data
      .dispatchColloquiAzienda(this["$store"], payload)
      .then(result => {
        for (let i = 0; i < result.length; i++) {
          articolazione = result[i].articolazione;
          if (!articolazioniList.includes(articolazione)) {
            articolazioniList.push(articolazione);
          }
        }
        schedule = {
          idArticolazione: 0,
          linkStanza: "",
          tableRecords: []
        };
        articolazioniList.forEach((element: any) => {
          schedule.idArticolazione = element;
          schedule.tableRecords = JSON.parse(
            JSON.stringify(this.dataTableParams)
          );
          for (let j = 0; j < result.length; j++) {
            if (result[j].articolazione === element) {
              link = result[j].linkStanza;
              schedule.tableRecords.records.push(result[j]);
            }
          }
          this.schedules.push({
            idArticolazione: schedule.idArticolazione,
            linkStanza: link,
            tableRecords: schedule.tableRecords
          });
        });
        bus.$emit("dataLoaded");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  loadPreferenzaColloquio() {
    data
      .dispatchPreferenzeColloquio(this["$store"], this.idIscrizioneAttivita)
      .then(result => {
        this.listaPreferenze = result;
        this.enableChanges = this.statoPeriodoIscrizione;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  loadGiorniColloqui() {
    var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var payload = {
      idAzienda: enterpriseInfo.idAzienda,
      idAnnoScolastico: idAnnoScolastico,
      idIstituto: this.idIstituto
    };
    data
      .dispatchGiorniColloquiAzienda(this["$store"], payload)
      .then(result => {
        this.giorniColloqui = result;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  deletePreferenza(idInformazioneColloquio: number) {
    if (confirm("Cancellare Preferenza Settore?")) {
      user
        .dispatchDeletePreferenzaColloquio(
          this["$store"],
          idInformazioneColloquio
        )
        .then(() => {
          bus.$emit(
            "successfullOperation",
            "Preferenza Settore cancellata con successo"
          );
          this.loadPreferenzaColloquio();
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    }
  }

  created() {
    if (
      this.idIscrizioneAttivita !== undefined &&
      this.idIscrizioneAttivita !== null
    ) {
      var token = localStorage.getItem("userToken");
      var parsedToken: any;
      if (token !== null) {
        parsedToken = userUtils.parseToken(token);
      }
      var payload = {
        idUtente: parsedToken.IdUtente,
        tipoSoggetto: parsedToken.IdTipoSoggetto,
        username: parsedToken.Username
      };
      user
        .dispatchSetUserInfo(this["$store"], payload)
        .then(() => {
          user
            .dispatchSetEnterpriseInfo(this["$store"])
            .then(() => {
              this.published = this.statoPubblicazione;
              this.loadPreferenzaColloquio();
              this.loadGiorniColloqui();
              this.loadColloqui();
              this.loadAllievi();
              bus.$emit("loadMenu");
            })
            .catch(() => {
              bus.$emit("stopLoading");
              auth.dispatchLogout(this["$store"]);
              user.dispatchClearState(this["$store"]);
              this["$router"].push("/sessionExpired");
            });
        })
        .catch(() => {
          bus.$emit("stopLoading");
          auth.dispatchLogout(this["$store"]);
          user.dispatchClearState(this["$store"]);
          this["$router"].push("/sessionExpired");
        });
    } else {
      router.push({
        name: "iscrizioniColloqui",
        params: {}
      });
    }

    bus.$on("loadColloqui", () => {
      this.schedules = [];
      this.loadColloqui();
    });

    bus.$on("loadPreferenzeWorkshop", async () => {
      this.showCreate = false;
      await this.$nextTick();
      this.showCreate = true;
      this.loadPreferenzaColloquio();
    });
  }
}
